<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-client-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-client-create>

<pg-client-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-client-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
